<template>
    <section class="panel-body">
        <!-- <small><strong>Consumo mês</strong></small> -->
        <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-success elevation-1"><i class="text-light fa fa-tag"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text"><strong>Plano: </strong><small class="text-uppercase"
                                v-if="auth_user.empresa.plano">{{auth_user.empresa.plano.nome}}</small></span>
                        <span class="info-box-number"> Renova: <small
                                v-if="dash.plano_empresa">{{formatDate(dash.plano_empresa.vencimento_padrao)}}</small>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-orange elevation-1"><i class="text-light fa fa-user"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Usuários</span>
                        <span class="info-box-number"> {{dash.consumo_mes.usuarios_consumidos}} /
                            {{dash.consumo_mes.usuarios_plano}} </span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-danger elevation-1"><i class="fa fa-envelope"></i></span>
                    <div class="info-box-content ">
                        <router-link to="/sms">
                            <span class="info-box-text text-white">Saldo envio SMS</span>
                            <span class="info-box-number text-white"> {{dash.consumo_mes.saldo_sms}} </span>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box bg-dark">
                    <span class="info-box-icon bg-info elevation-1"><i class="fa fa-upload"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Uploads <span
                                v-if="auth_user.empresa.plano && auth_user.empresa.plano.nome != 'Trial'">/
                                mês</span></span>
                        <span class="info-box-number"> {{dash.consumo_mes.arquivos_consumidos}} /
                            {{dash.consumo_mes.arquivos_plano}} </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-9">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <small><strong> Seus Documentos Mês: </strong></small>
                        <div class="col-12 p-0">
                            <apexchart height="300px" :options="meusArquivos.chartOptions"
                                :series="meusArquivos.series" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <small><strong> Por Usuario: </strong></small>
                        <div class="col-12 p-0">
                            <apexchart height="300px" :options="porUsuario.chartOptions" :series="porUsuario.series" />
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row m-0">
                    <div class="p-3">
                        <h3>
                            <span class="info-box-icon"><i class="text-info fa fa-shield"></i></span>
                            <span> Login em 2 estapas: </span>
                            <router-link to="/profile">
                                <span v-if="auth_user.two_factory_type" class="text-green">habilitado</span>
                                <span v-else class="text-red">desabilitado</span>
                            </router-link>
                        </h3>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3">
                <small><strong>Geral: </strong></small>
                <router-link to="/home">
                    <div class="info-box bg-info">
                        <span class="info-box-icon"><i class="fa fa-file"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Documentos</span>
                            <span class="info-box-number">{{dash.plataforma_geral.documentos_arquivados}} -
                                <small>{{dash.plataforma_geral.armazenamento}}</small></span>
                        </div>
                    </div>
                </router-link>
                <router-link to="/finalizados">
                    <div class="info-box bg-success">
                        <span class="info-box-icon"><i class="fa fa-check-circle-o"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Finalizados</span>
                            <span class="info-box-number"> {{dash.assinaturas.assinados}} </span>
                        </div>
                    </div>
                </router-link>
                <router-link to="/pendentes">
                    <div class="info-box bg-orange">
                        <span class="info-box-icon"><i class="text-light fa fa-clock-o"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text text-light">Pendentes</span>
                            <span class="info-box-number text-light"> {{dash.assinaturas.pendentes}} </span>
                        </div>
                    </div>
                </router-link>
                <router-link to="/expirados">
                    <div class="info-box bg-danger">
                        <span class="info-box-icon"><i class="fa fa-times-circle-o"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">Expirados</span>
                            <span class="info-box-number"> {{dash.assinaturas.expirados}} </span>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                totAssinados: [],
                totPendentes: [],
                totExpirados: [],
                dash: {
                    plataforma_geral: {
                        armazenamento: null,
                        documentos_arquivados: 0
                    },
                    plano_corporativo: {},
                    consumo_mes: {
                        arquivos: 0,
                        sms: 0
                    },
                    usuarios: {
                        usuarios: 0,
                        simples_sinatarios: 0
                    },
                    assinaturas: {
                        assinados: 0,
                        pendentes: 0,
                        expirados: 0
                    },
                    suas_solicitacoes: {
                        assinados: 0,
                        pendentes: 0
                    },
                    assinaturas_usuario: [{
                        nome: null,
                        assinados_count: 0,
                        pendentes_count: 0,
                        expirados_count: 0
                    }]
                },
                meusArquivos: {
                    series: [],
                    chartOptions: {
                        chart: {
                            type: "bar",
                            height: 'auto',
                            stacked: false,
                            toolbar: {
                                show: false
                            },
                            zoom: {
                                enabled: false
                            }
                        },
                        colors: ['#28a74595', '#fd7e1495', '#dc354595'],
                        //colors: ['#dce4ea', '#48a8a7', '#3f5d9b'],
                        dataLabels: {
                            enabled: false,
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                            },
                        },
                        xaxis: {
                            type: "category",
                            categories: [],
                            labels: {
                                show: true,
                                rotate: -45,
                                rotateAlways: true,
                            }
                        },
                        yaxis: {
                            labels: {
                                formatter: function (value) {
                                    if (value == 'Infinity') {
                                        return 100;
                                    }
                                    return parseFloat(value);
                                }
                            },
                        },
                        legend: {
                            position: "bottom",
                            formatter: function (seriesName, opts) {
                                return `${seriesName} ${((opts.w.globals.series[opts.seriesIndex].length) && (seriesName.slice(0,5) != 'Total') ) ? 
                   parseFloat(opts.w.globals.series[opts.seriesIndex].reduce((total, value) => total + value)): ''}`
                            },
                        }
                    },
                },
                porUsuario: {
                    series: [],
                    chartOptions: {
                        chart: {
                            type: "bar",
                            height: 'auto',
                            stacked: true,
                            toolbar: {
                                show: false
                            },
                            zoom: {
                                enabled: false
                            }
                        },
                        colors: ['#28a74595', '#fd7e1495', '#dc354595'],
                        dataLabels: {
                            enabled: false,
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                            },
                        },
                        xaxis: {
                            type: "category",
                            categories: [],
                            labels: {
                                show: true,
                                rotate: -45,
                                rotateAlways: true,
                            }
                        },
                        yaxis: {
                            labels: {
                                formatter: function (value) {
                                    if (value == 'Infinity') {
                                        return 100;
                                    }
                                    return parseFloat(value);
                                }
                            },
                        },
                        legend: {
                            position: "bottom",
                            formatter: function (seriesName, opts) {
                                return `${seriesName} ${((opts.w.globals.series[opts.seriesIndex].length) && (seriesName.slice(0,5) != 'Total') ) ? 
                   parseFloat(opts.w.globals.series[opts.seriesIndex].reduce((total, value) => total + value)): ''}`
                            },
                        },
                    },
                },
            }
        },
        watch: {
            $route(data) {
                if (data.name === 'dashboard' && this.user.ambiente == 'S') {
                    this.$router.push('/inbox');
                    return;
                }
                if (data != 'S') {
                    this.$destroy();
                    return
                }
            },
            'user.ambiente'(data) {
                if (data == 'S') {
                    this.$router.push('/inbox');
                }
            }
        },
        mounted() {
            new Promise(async (myResolve, myReject) => {
                this.getDashInicial();
                myResolve();
            }).finally(() => {
                this.loading = false;
            })
        },
        computed: {
            user() {
                return this.$store.state.user.data;
            },
        },
        methods: {
            async getDashInicial() {
                await this.$store.dispatch("getDashboard").then((response) => {
                    this.dash = response;

                    //Status Meus Arquivos
                    this.meusArquivos.series = [];
                    this.meusArquivos.series.push({
                        name: 'Finalizados',
                        data: [this.dash.solicitacoes.assinados],
                    }, {
                        name: 'Pendente',
                        data: [this.dash.solicitacoes.pendentes],
                    }, {
                        name: 'Expirados',
                        data: [this.dash.solicitacoes.expirados],
                    });

                    this.meusArquivos.chartOptions.xaxis.categories.push('');

                    //Grafico por usuarios
                    this.porUsuario.series = [];
                    this.totAssinados = [];
                    this.totPendentes = [];
                    this.totExpirados = [];

                    this.dash.assinaturas_usuario.map(assinaturas => {
                        this.totAssinados.push(assinaturas.assinados_count);
                        this.totPendentes.push(assinaturas.pendentes_count);
                        this.totExpirados.push(assinaturas.expirados_count);

                        this.porUsuario.chartOptions.xaxis.categories.push(assinaturas.nome.split(
                            " ")[0]);
                    });

                    this.porUsuario.series = [{
                        name: 'Finalizados',
                        data: this.totAssinados
                    }, {
                        name: 'Pendentes',
                        data: this.totPendentes
                    }, {
                        name: 'Expirados',
                        data: this.totExpirados
                    }];
                });
            }
        }
    }
</script>

<style>
    .bg-dark {
        background-color: #4b545c !important;
    }
</style>